// Actions that more than one route dispatches.
//
// `loadCourseGroups` used to live in App.js and be dispatched exactly once, at boot. That
// was fine while nothing on the site wrote to a course, but the country page's admin panel
// merges, hides and renames them — and a table still showing a course that has just been
// merged away is a table you can merge it away from a second time.

export const loadCourseGroups = () => ({
  type: 'LOAD_COURSE_GROUPS',
  payload: {
    request: {
      url: `/v3/course`,
    },
  },
})
